// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__udZKm","logo":"styles_logo__6zrBN","actions":"styles_actions__ZMPHu","user":"styles_user__0hSkj","dev":"styles_dev__bjvqX"};